import { ContentfulLivePreview } from '@contentful/live-preview'

import { Container } from '../../components/container'
import { CmsColor } from '../../models/cms-color'
import { cn } from '../../utils/cn'
import { RichText } from '../helper-components/rich-text'

interface InfoCmsProps {
  id: string
  title: any | string
  subtitle: any | string
  secondarySubtitle: any | string
  collection: Array<any>
  color: CmsColor
}

export const InfoHighlightBlockCms = (props: InfoCmsProps) => {
  function renderCard(card: any) {
    return (
      <div className="flex flex-col items-center text-center">
        <div
          className={cn(
            props.collection?.length > 1 ? 'max-w-[18.125rem]' : 'max-w-[30rem]'
          )}
        >
          <div
            className="text-sm font-medium uppercase"
            {...ContentfulLivePreview.getProps({
              entryId: props.id,
              fieldId: 'label',
              locale: 'en-us',
            })}
          >
            {card.label}
          </div>
          <RichText
            className="text-primary font-serif text-[4rem]"
            json={card.title?.json}
            links={card.title?.links}
            {...ContentfulLivePreview.getProps({
              entryId: props.id,
              fieldId: 'title',
              locale: 'en-us',
            })}
          />
          <RichText
            json={card.description?.json}
            links={card.description?.links}
            {...ContentfulLivePreview.getProps({
              entryId: props.id,
              fieldId: 'description',
              locale: 'en-us',
            })}
          />
        </div>
      </div>
    )
  }

  return (
    <Container
      style={{
        backgroundColor: props.color?.backgroundColor || '',
        color: props.color?.textColor || '',
      }}
      id={`${props.id}`}
      className="scroll-mt-25"
    >
      <div className="pt-20 pb-14 lg:px-28 lg:pt-24">
        <h2>
          <RichText
            className={cn(
              'pb-12 lg:pb-20 text-center',
              props.collection.length > 2 ? 'text-5xl' : 'text-3xl'
            )}
            json={props.title?.json}
            links={props.title?.links}
          />
        </h2>
        <RichText
          json={props.subtitle?.json}
          links={props.subtitle?.links}
          {...ContentfulLivePreview.getProps({
            entryId: props.id,
            fieldId: 'subtitle',
            locale: 'en-us',
          })}
        />
        <div
          className={cn(
            'flex flex-col md:flex-row items-center gap-12 sm:gap-6 justify-center'
          )}
        >
          {props.collection.map((item, i) => (
            <div key={i} className="mx-2 items-center md:pb-16">
              {renderCard(item)}
            </div>
          ))}
        </div>
        {props.secondarySubtitle?.json && (
          <RichText
            className="text-center text-lg lg:text-2xl mt-12 lg:mt-16"
            json={props.secondarySubtitle?.json}
            links={props.secondarySubtitle?.links}
            {...ContentfulLivePreview.getProps({
              entryId: props.id,
              fieldId: 'secondarySubtitle',
              locale: 'en-us',
            })}
          />
        )}
      </div>
    </Container>
  )
}
